import React, { useState } from "react";

const Context = React.createContext({});

export function CheatsContextProvider({ children }) {
  const [cheats, setCheats] = useState([]);
  const [currentgame, setCurrentgame] = useState("all");
  const [loadingCheats, setLoadingCheats] = useState(false);
  const [editingCheat, setEditingCheat] = useState({});
  const [currentCheat, setCurrentCheat] = useState({});
  const [questions, setQuestions] = useState([]);
  const [categories, setCategories] = useState([]);

  return (
    <Context.Provider
      value={{
        cheats,
        setCheats,
        currentgame,
        setCurrentgame,
        loadingCheats,
        setLoadingCheats,
        editingCheat,
        setEditingCheat,
        currentCheat,
        setCurrentCheat,
        questions,
        setQuestions,
        categories,
        setCategories,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default Context;
